import { Menu as PrimeMenu } from 'primeng/menu';

import { NgTemplateOutlet } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';
import {
  input,
  output,
  computed,
  viewChild,
  Component,
  type ElementRef,
  type TemplateRef,
  ViewEncapsulation,
  ChangeDetectionStrategy,
} from '@angular/core';

import { SvgIcon } from '@shared/ui/svg-icon';

import type { MenuItem } from './menu-item';

@Component({
  selector: 'app-menu',
  imports: [PrimeMenu, SvgIcon, RouterLink, NgTemplateOutlet, RouterLinkActive],
  templateUrl: './menu.html',
  styleUrl: './menu.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Menu {
  public readonly items = input<MenuItem[]>([]);
  public readonly styleClass = input<string>();
  public readonly appendTo = input<
    HTMLElement | ElementRef | TemplateRef<any> | 'self' | 'body' | null | undefined | any
  >(undefined);

  public readonly opened = output<void>();
  public readonly closed = output<void>();

  private readonly menuRef = viewChild.required(PrimeMenu);

  protected readonly resolvedStyleClass = computed(() => ['app-menu', this.styleClass()].filter(Boolean).join(' '));

  public toggle(event: Event): void {
    this.menuRef().toggle(event);
  }

  public show(event: Event): void {
    this.menuRef().show(event);
  }

  public hide(): void {
    this.menuRef().hide();
  }
}
